import { cn } from "@/lib/tailwind";
import React, { ReactNode } from "react";
interface ISpacerProps {
  children: ReactNode;
  space?: `mb-[${number}rem] md:mb-[${number}rem]`;
}
const Spacer = ({ children, space = "mb-[1.75rem] md:mb-[2.25rem]" }: ISpacerProps) => {
  return <div className={cn("w-full", space)}>{children}</div>;
};

export default Spacer;
